import * as React from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Checkbox from '@mui/material/Checkbox';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';

//image={props.image}
//title={value.title} desc={value.description} wordData={value.wordList}
export default function MediaCard(props) {

  const handleChange = (event) => {
    console.log("event triggered", event);
  };

  return (
    <Card sx={{ maxWidth: 345, minWidth: 200, }}>
      <CardMedia
        component="img"
        height="140"
        width="120"
        src={`data:image/png;base64, ${props.imgbase64}`}
        alt="green iguana"
      />


      <CardContent sx={{mb:0}}>
        <Typography gutterBottom variant="h5" component="div">
          {props.title}
        </Typography>

        <Grid container>

        <Grid item>
          <Typography variant="body2" color="text.secondary" sx={{mt:1.1}}>
            {props.wordCount} Words
          </Typography>
        </Grid>

        <Grid item>
          <Tooltip title={props.include ? "All words selected" : "Partial/None selected"} sx={{ml:2}}>
            <Checkbox size="small"
            style ={{
              color: "#aaaaaa",
            }}
            // onChange={() => props.updateCheckbox(props.index)} 
            onChange={() => 0} 
            checked={props.include === true} label="Include" />
          </Tooltip>
          </Grid>

          <Grid item>
          <Button onClick={() => props.handleOpen(props.index)} sx={{ml:1, mt:0.1}}>
            EDIT
          </Button>
          </Grid>

          </Grid>
      </CardContent>

      <LinearProgress variant="determinate" value={props.percentSelected} />
      
    </Card>
  );
}